"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AppointmentCancelContainer_1 = __importDefault(require("./AppointmentCancelContainer"));
exports.default = AppointmentCancelContainer_1.default;
//# sourceMappingURL=index.js.map